export const REPORTS_TYPES = {
  expediente: 1,
  prescripcion: 2,
  incapacidad: 3
}
